/**
 * Created by christian on 3/5/2015.
 */

module cr.entity
{
    class TreeManagerCtrl {
        public setting:any;

        getSelectedNode=()=>
        {
            return this.setting==null?"zen":this.setting;
        }

        getTree=()=>{
            return this.$scope.tree;
        }


        constructor(private $scope){

            $scope.treeOptions={
                accept:(sourceNodeScope,destNodeScope,destIndex)=>{
                    console.log("source: "+angular.toJson(sourceNodeScope));
                    console.log("dest: "+angular.toJson(destNodeScope));
                    console.log("destIndex: "+angular.toJson(destIndex));

                    return destIndex==0;
                    return true;
                }
            };


            $scope.getSelectedNode=()=>{return this.getSelectedNode()};
        }
    }


    entityModule.directive('crTreeViewer', function() {
        return {
            restrict: 'AEC',
            transclude: true,
            scope: { tree:"=tree" },
            link: function(scope, element, attrs, ctrl, transclude)
            {

                transclude(scope, function(clone, scope) {
                    element.append(clone);
                });
            },

            templateUrl: "modules/entity/views/treeviewer.html",
            controller:['$scope',TreeManagerCtrl]
        };
    })
}

